// Importing toastify module
import { toast } from "react-toastify";

// Import toastify css file
import "react-toastify/dist/ReactToastify.css";

export const toastError = (message) => {
  return toast.error(message);
};
export const toastSuccess = (message) => {
  return toast.success(message);
};
export const toastWarning = (message) => {
  return toast.warn(message);
};